import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const PROTOCOL_DETECTOR_REGEX = /^(https?|ftp):\/\//

function FooterSubNav({ link }) {
  const { url, title, payload } = link
  const useNewWindow = PROTOCOL_DETECTOR_REGEX.test(url) || link.opensNewWindow
  const finalUrl = link.asset ? link.asset.file.url : url
  const payloadJSON = payload ? JSON.parse(payload?.internal?.content) : null
  const getSubNavItem = () => {
    if (payloadJSON?.openConsentManager) {
      return (
        <button
          className="drop-down__button"
          type="submit"
          onClick={() => {
            window.consentManager.openConsentManager()
          }}
        >
          {title}
        </button>
      )
    }
    if (useNewWindow) {
      return (
        <a
          className="drop-down__link"
          href={finalUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-event={title}
        >
          {title}
        </a>
      )
    }
    return (
      <Link className="drop-down__link" to={finalUrl} data-event={title}>
        {title}
      </Link>
    )
  }

  const subNavItem = getSubNavItem()
  return (
    <li className="drop-down__item" key={title}>
      {subNavItem}
    </li>
  )
}

FooterSubNav.propTypes = {
  link: PropTypes.object.isRequired
}

export default FooterSubNav
